module.exports = __webpack_public_path__ + "static/media/plan.2d508bd5.png";